<template>
    <div class="main_container ">
      <div class="jbxxDiv">
        <!-- 活动标题 & 所属城市 & 活动时间 -->
        <p class="jbxx">基本信息</p>
        <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;display:flex;position: relative;">
            <el-form-item label="活动标题：" style="display:flex;width:30%" required>
                <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.Name" placeholder="请输入活动名称(20字符以内)" maxlength="20"/>
            </el-form-item>
            <el-form-item label="所属城市：" class="optionscity" style="display:flex;width:30%;margin-left:10px;" required>
                <el-cascader v-if="type == 0 ? true : false" :disabled="disablecs" placeholder="请选择城市"
                v-model="hdcs" :options="options" style="width:100%" filterable clearable
                @change="handleChange"/>
                <el-input v-else disabled style="margin:0 10 0 10px;" v-model="cityname"/>
            </el-form-item>
            <el-form-item label="活动时间：" style="display:flex;width:50%" required>
                  <el-date-picker :disabled="type==2"
                    v-model="hdsj"
                    :editable="iseditable"
                    style="width:100%;cursor:pointer"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="请选择活动开始日期"
                    @change="changetime"
                    end-placeholder="请选择活动结束日期"/>
                </el-form-item>
        </el-form>
        <div class="banner">
            <!-- 活动banner -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsBanner"/><label>活动banner</label>
            </div>
            <div class="showDiv mainbanner" v-if="datas.IsBanner">
                <div style="margin-top:12px;white-space: nowrap;">活动banner : </div>
                <div style="display:flex;margin-left:20px;">
                    <div>
                        <p style="text-align:center;color:#888">PC端</p>
                        <p>
                            <el-upload :disabled="type==2" class="avatar-uploader" style action
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload">
                                <img class="avatar" v-if="datas.Pc_Banner" :src="ResultUrlPc" style="width:650px;height:270px;"/>
                                <i v-else class="el-icon-plus avatar-uploader-icon"/>
                            </el-upload>
                        </p>
                        <p style="text-align:center;color:#888">建议尺寸：1920*450，支持的图片格式：jpg、png。</p>
                    </div>
                    <div style="margin-left:5%">
                    <p style="text-align:center;color:#888">小程序</p>
                    <p>
                        <el-upload :disabled="type==2" class="avatar-uploader1" style action
                        :show-file-list="false"
                        :before-upload="beforeAvatarUploadtwo">
                        <img class="avatar" v-if="datas.Wechat_Banner" :src="ResultUrlXcx" style="width:270px;height:270px;"/>
                        <i v-else class="el-icon-plus avatar-uploader-icon1"/>
                        </el-upload>
                    </p>
                    <p style="text-align:center;color:#888">建议尺寸：750*750，支持的图片格式：jpg、png。</p>
                    </div>
                </div>
            </div>
            <!-- 报名区域 -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsSignUp"/><label>报名区域</label>
            </div>
            <div class="showDiv" v-if="datas.IsSignUp">
              <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;">
                <el-form-item label="区域标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.SignUpTitle" placeholder="请输入报名区域标题(10字符以内)" maxlength="10"/>
                </el-form-item>
              </el-form>
            </div>
            <!-- 活动方案 -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsScheme"/><label>活动方案</label>
            </div>
            <div class="showDiv" v-if="datas.IsScheme">
              <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;">
                <el-form-item label="方案标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.SchemeTitle" placeholder="请输入活动方案标题(10字符以内)" maxlength="10"/>
                </el-form-item>
              </el-form>
              <!-- 活动政策 -->
              <div style="display:flex;margin-top:20px">
                  <div style="white-space: nowrap;">活动政策：</div>
                  <div>
                      <!-- 图片上传组件辅助-->
                      <el-upload :disabled="type==2"
                      style="margin-top:-20px"
                      class="avatar-uploaderfuHdzc"
                      action="serverUrl"
                      name="img"
                      :show-file-list="false"
                      :before-upload="beforeUploadPolicy"/>
                      <!--富文本编辑器组件-->
                      <el-row>
                          <quill-editor :disabled="type==2" v-model="datas.Policy" ref="hdzcQuillEditor" :options="editorOptionHdzc"/>
                      </el-row>
                  </div>
              </div>
            </div>
            <!-- 活动商品 -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsGoods"/><label>活动商品</label>
            </div>
            <div class="showDiv" v-if="datas.IsGoods">
              <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;">
                <el-form-item label="秒杀标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.GoodsTitle1" placeholder="限时秒杀的商品(10字符以内)" maxlength="10"/>
                </el-form-item>
                <el-form-item label="商品标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.GoodsTtitle2" placeholder="参与活动的商品(10字符以内)" maxlength="10"/>
                </el-form-item>
              </el-form>
                <div style="display:flex;margin-top:20px">
                  <div style="margin-top:12px;white-space: nowrap;">商品列表 : </div>
                  <div style="margin-left:20px;">
                    <el-table :data="datas.Goods" stripe border class="ban_tab"
                      :header-cell-style="{background:'#bbbbbb'}"
                      style="height:auto;margin-left:-14px;margin-top:10px">
                      <el-table-column prop="Name" label="商品名称" align="center">
                        <template scope="scope">
                          <span :title="scope.row.Name" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.Name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="BrandName" label="所属品牌" align="center">
                        <template scope="scope">
                          <span :title="scope.row.BrandName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" >{{scope.row.BrandName}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsSkName" label="是否秒杀" align="center">
                        <template scope="scope">
                          <span :title="scope.row.IsSkName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.IsSkName}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="OrderNumber" label="顺序" align="center">
                        <template scope="scope">
                          <span :title="scope.row.OrderNumber" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.OrderNumber}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column v-if="SeeDetails" prop label="操作" width="270px" fixed="right" align="center">
                        <template slot="header">
                          <button class="addCanzhan" @click="addSp()">新增参展商品</button>
                        </template>
                        <template scope="scope" class="tempSpan">
                          <span @click="deleteone(scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                            <i class="el-icon-delete"/>删除
                          </span>
                          <span @click="spUpordown(0,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                            <i class="el-icon-upload2"/>向上
                          </span>
                          <span @click="spUpordown(1,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;">
                            <i class="el-icon-download"/>向下
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
                      <el-pagination
                        layout="prev, pager, next"
                        @current-change="hdspCurrentChange"
                        :page-size="10"
                        :current-page="pageIndex"
                        :total="total"
                        style="float:right;margin-right:14px"/>
                    </el-col>
                  </div>
                </div>
            </div>
            <!-- 活动品牌 -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsBrand"/><label>活动品牌</label>
            </div>
            <div class="showDiv" v-if="datas.IsBrand">
              <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;display:flex;position: relative;">
                <el-form-item label="品牌标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.BrandTittle" placeholder="请输入活动品牌标题(10字符以内)" maxlength="10"/>
                </el-form-item>
              </el-form>
              <div style="display:flex;margin-top:20px">
                <div style="margin-top:12px;white-space: nowrap;">品牌列表 : </div>
                  <div style="margin-left:20px;">
                    <el-table :data="datas.Brands" stripe border class="ban_tab"
                      :header-cell-style="{background:'#bbbbbb'}"
                      style="height:auto;margin-left:-14px;margin-top:10px">
                      <el-table-column prop="Name" label="品牌名称" align="center">
                        <template scope="scope">
                          <span :title="scope.row.Name" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.Name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="OrderNumber" label="顺序" align="center">
                        <template scope="scope">
                          <span :title="scope.row.OrderNumber" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.OrderNumber}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column v-if="SeeDetails" label="操作" width="270px" fixed="right" align="center">
                        <template slot="header">
                          <button class="addCanzhan" @click="addPp()">新增参展品牌</button>
                        </template>
                        <template scope="scope" class="tempSpan">
                          <span @click="deleteTwo(scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;"><i class="el-icon-delete"/>删除</span>
                          <span @click="ppUpordown(0,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;"><i class="el-icon-upload2"/>向上</span>
                          <span @click="ppUpordown(1,scope)" style="color:#6786b4;margin-left:8px;cursor: pointer;"><i class="el-icon-download"/>向下</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
                      <el-pagination
                        layout="prev, pager, next"
                        @current-change="hdppCurrentChange"
                        :page-size="10"
                        :current-page="pageIndexTwo"
                        :total="totalTwo"
                        style="float:right;margin-right:14px"/>
                    </el-col>
                  </div>
              </div>
            </div>
            <!-- 活动地址 -->
            <div class="inputDiv">
              <input :disabled="type==2" type="checkbox" v-model="datas.IsAddress"/><label>活动地址</label>
            </div>
            <div class="showDiv" v-if="datas.IsAddress">
              <el-form :inline="true" class="demo-form-inline findform" style="margin-top:10px;display:flex;position: relative;">
                <el-form-item label="地址标题 : " style="display:flex;width:30%">
                    <el-input :disabled="type==2" style="margin:0 10px;" v-model="datas.AddressTitle" placeholder="请输入活动地址标题(10字符以内)" maxlength="10"/>
                </el-form-item>
              </el-form>
              <div style="display:flex;margin-top:20px">
                <div style="white-space: nowrap;">活动地址：</div>
                <div>
                    <!-- 图片上传组件辅助-->
                    <el-upload :disabled="type==2"
                    style="margin-top:-20px"
                    class="avatar-uploaderfuHddz"
                    action="serverUrl"
                    name="img"
                    :show-file-list="false"
                    :before-upload="beforeUploadAddress"/>
                    <!--富文本编辑器组件-->
                    <el-row>
                        <quill-editor :disabled="type==2" v-model="datas.Address" ref="hddzQuillEditor" :options="editorOptionHddz"/>
                    </el-row>
                </div>
              </div>
            </div>
            <!-- 提交按钮 -->
            <div class="suBmit">
              <el-button @click="goback()">返 回</el-button>
              <el-button type="danger" v-if="SeeDetails" @click="eitm()">保 存</el-button>
            </div>
        </div>
      </div>
      <!-- 新增参展商品 -->
      <addExhibitorsCategory v-if="commodityVisible" :guid="guid" :cityId="datas.CityId" ref="addCommodity" @refreshDataList="refreshSelectGoods"/>
      <!-- 新增参展品牌 -->
      <addExhibitorsBrand v-if="brandVisible" :guid="guid" :cityId="datas.CityId" ref="addBrand" @refreshDataList="refreshSelectBrand"/>
    </div>
</template>
<script>
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"] // remove formatting button
];
import { UploadImgForServer } from '../../api/newOss';
import { getSelectRegionOfflineActiveById, DeleteGoods, DeleteBrands,
  getCreateGUID, SelectROAGoods, SelectROABrands, getProvinceAndCityAndZoneByDataType, 
  UpdateGoodsOrderNum, UpdateBrandsOrderNum, InsertRegionOfflineActive, UpdateRegionOfflineActive} from "../../api/api";
import addExhibitorsCategory from './addExhibitorsCategory'
import addExhibitorsBrand from './addExhibitorsBrand'
export default {
  name: "ActivityDetails",
  data () {
    return {
      type: 0, // 数据状态, 0: 新增, 1: 编辑, 2: 查看
      id: "",
      guid: "", // 数据的id
      loading: false,
      disablecs: false,
      SeeDetails: true, // 保存按钮
      datas: {
        Id: 14, // 活动ID
        Name: "", // 活动标题
        ProviceId: "", // 活动所属省ID
        CityId: "", // 活动所属市ID
        STime: "", // 开始时间
        ETime: "", // 结束时间
        Pc_Banner: "", // pc端banner
        Wechat_Banner: "", // 小程序banner
        Policy: "", // 活动政策
        Address: "",  // 活动地址
        Status: 0, // 活动状态
        OperatorId: 0, // 操作人ID
        IsBanner: 1, // 是否启用活动banner 0未启用，1启用
        IsSignUp: 1, // 是否启用报名区域 0未启用，1启用
        IsScheme: 1, // 是否启用方案区域 0未启用，1启用
        IsGoods: 1, // 是否启用商品区域 0未启用，1启用
        IsBrand: 1, // 是否启用品牌区域 0未启用，1启用
        IsAddress: 1, // 是否启用地址区域 0未启用，1启用
        SignUpTitle: "", // 报名区域title
        SchemeTitle: "", // 活动方案title
        GoodsTitle1: "", // 活动商品秒杀标题
        AddressTitle: "", // 活动地址title
        Goods: [], // 活动商品列表
        Brands: [], // 活动品牌列表
        Guid: "", // Guid，用于维护活动里面的品牌和商品
        GoodsTtitle2: "", //活动商品title
        BrandTittle: "", // 活动品牌title
      },
      hdsj: [], // 活动时间
      hdcs: [], // 活动省市
      cityname: "", // 编辑/查看反显省市
      commodityVisible: false,
      brandVisible: false,
      iseditable: false,
      ResultUrlPc: "", // PC图片链接拼接 src
      ResultUrlXcx: "", // 小程序图片链接拼接 src      
      pageIndex:1, // 参展商品分页默认第一页
      total:1, // 参展商品分页
      pageIndexTwo:1, // 参展品牌分页默认第一页
      totalTwo:1, // 参展品牌分页
      optionsindex: "",
      goodIdarr:[],
      options: [], // 所属城市
      addExhibitorsCategory: false, // 新增参展商品
      addExhibitorsBrand: false, // 新增参展品牌
      // 活动政策
      editorOptionHdzc: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector(".avatar-uploaderfuHdzc input").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      // 活动地址
      editorOptionHddz: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector(".avatar-uploaderfuHddz input").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          }
        }
      },
      goodIdarr:[],
      pickerOptions: { // 活动时间限制
        disabledDate(time) {
          return time.getTime() < Date.now()-8.64e7;
        },
      }
    }
  },
  components: {
    addExhibitorsCategory,
    addExhibitorsBrand
  },
  methods: {
    // 参展商品列表 返回数据
    refreshSelectGoods(goods) {
      // this.datas.Goods = goods
      this.getHdspList()
    },
    // 参展品牌列表 返回数据
    refreshSelectBrand(brandList) {
      // this.datas.Brands = brandList
      this.gethdppList()
    },
    // 初始化页面
    init() {
      this.type = this.$route.query.type || 0
      this.id = this.$route.query.Id || ""
      // 新增 添加参展商品
      if (this.type == 0) {
        var obj = {}
        // 获取guid
        getCreateGUID(obj).then(data=>{
          if(data.ResultCode == 1){
              this.guid = data.ResultObj
          }
        })
      }
      // 编辑/查看
      if (this.id) {
        this.disablecs = true;
        var obj = {
          id: this.id
        }
        getSelectRegionOfflineActiveById(obj).then(data=>{
          if(data.ResultCode == 1){
              this.datas = data.ResultObj;
              this.guid = this.datas.Guid;
              this.getHdspList();
              this.gethdppList();
              this.hdsj = [this.datas.STime, this.datas.ETime]; // 活动时间
              this.ResultUrlPc = this.datas.Pc_Banner;
              this.ResultUrlXcx = this.datas.Wechat_Banner;
              this.cityname = this.datas.CityName
              // this.hdcs = [ this.datas.ProviceId, this.datas.CityId] // 活动城市
          }else{
            this.datas = []
          }
        })
      }
      // 查看
      if (this.type == 2) {
        this.SeeDetails = false;
      }
    },
    // 查询已添加的活动商品
    getHdspList () {
      var obj = {
        guid: this.guid,
        pageIndex: this.pageIndex, // 页码
        pageSize: 10 // 每页行数
      }
      SelectROAGoods(obj).then(data=>{
        if(data.ResultCode == 1){
            this.datas.Goods = data.ResultObj
            this.total = data.RowsCount;
        }else{
          this.datas.Goods = [];
          this.total = 0
        }
      })
    },
    // 查询已添加的活动品牌
    gethdppList () {
      var obj = {
        guid: this.guid,
        pageIndex: this.pageIndexTwo, // 页码
        pageSize: 10 // 每页行数
      }
      SelectROABrands(obj).then(data=>{
        if(data.ResultCode == 1){
            this.datas.Brands = data.ResultObj
            this.totalTwo = data.RowsCount;
        }else{
          this.datas.Brands = [];
          this.totalTwo = 0
        }
      })
    },
    // 新增参展商品
    addSp () {
      if (this.datas.CityId == 0) {
        this.$swal({
          type:"warning",
          text:"请选择城市"
        })
        return;
      }
      this.commodityVisible = true
      this.$nextTick(() => {
        this.$refs.addCommodity.init()
      })
    },
    // 新增参展品牌
    addPp () {
      if (this.datas.CityId == 0) {
        this.$swal({
          type:"warning",
          text:"请选择城市"
        })
        return;
      }
      this.brandVisible = true
      this.$nextTick(() => {
        this.$refs.addBrand.init()
      })
    },
    // 验证是否为空
    isempty (value) {
      return value == "" || value == null || value == undefined
    },
    // 保存按钮
    eitm () {
      if (this.datas.Name == "") {
        this.$swal({
          type:"warning",
          text:"活动标题不能为空"
        })
        return;
      }
      if (this.datas.CityId == 0) {
        this.$swal({
          type:"warning",
          text:"请选择所属城市"
        })
        return;
      }
      if (this.hdsj == "") {
        this.$swal({
          type:"warning",
          text:"活动时间不能为空"
        })
        return;
      }
      if (this.datas.IsBanner == 1 && this.isempty(this.datas.Pc_Banner)) {
        this.$swal({
            type:"warning",
            text:"请上传PC端主页banner"
          })
        return;
      }
      if (this.datas.IsBanner == 1 && this.isempty(this.datas.Wechat_Banner)) {
        this.$swal({
            type:"warning",
            text:"请上传小程序主页banner"
          })
        return;
      }
      if (this.datas.IsSignUp){
        if (this.isempty(this.datas.SignUpTitle)){
          this.$swal({
            type:"warning",
            text:"报名区域标题不能为空"
          })
          return;
        }
      }
      if (this.datas.IsScheme) {
        if (this.isempty(this.datas.SchemeTitle)) {
          this.$swal({
            type:"warning",
            text:"活动方案标题不能为空"
          })
          return;
        }
        if (this.isempty(this.datas.Policy)) {
          this.$swal({
            type:"warning",
            text:"活动政策不能为空"
          })
          return;
        }
      }
      if (this.datas.IsGoods) {
        if (this.isempty(this.datas.GoodsTitle1)) {
          this.$swal({
            type:"warning",
            text:"活动商品秒杀标题不能为空"
          })
          return;
        }
        if (this.isempty(this.datas.GoodsTtitle2)) {
          this.$swal({
            type:"warning",
            text:"活动商品标题不能为空"
          })
          return;
        }
      }
      if (this.datas.IsBrand) {
        if (this.isempty(this.datas.BrandTittle)) {
          this.$swal({
            type:"warning",
            text:"活动品牌标题不能为空"
          })
          return;
        }
      }
      if (this.datas.IsAddress) {
        if (this.isempty(this.datas.AddressTitle)) {
          this.$swal({
            type:"warning",
            text:"活动地址标题不能为空"
          })
          return;
        }
        if (this.isempty(this.datas.Address)) {
          this.$swal({
            type:"warning",
            text:"活动地址内容不能为空"
          })
          return;
        }
      }
      this.loading = true;
      this.$emit("loadingfun", this.loading);
      // if (this.isempty(pcBanner)) {} else {
      //   pcBanner.replace(localStorage.BaseUrl, "");
      //   pcBanner.replace("https://www.taozhuanr.com/","");
      // }
      // if (this.isempty(weChatBanner)) {} else {
      //   weChatBanner.replace(localStorage.BaseUrl, "");
      //   weChatBanner.replace("https://www.taozhuanr.com/","");
      // }
      var obj = {
        Name: this.datas.Name, // 活动标题
        ProviceId: this.datas.ProviceId, // 活动所属省ID
        CityId: this.datas.CityId, // 活动所属市ID
        STime: this.datas.STime, // 活动开始时间
        ETime: this.datas.ETime, // 活动结束时间
        IsBanner: Number(this.datas.IsBanner), // 是否启用Banner区域，0未启用，1启用
        PcBanner: this.datas.Pc_Banner, // pc端Banner地址
        WechatBanner: this.datas.Wechat_Banner, // 小程序Banner地址
        IsSignUp: Number(this.datas.IsSignUp), // 是否启用报名区域，0未启用，1启用
        SignTitle: this.datas.SignUpTitle, // 报名区域区域标题
        IsScheme: Number(this.datas.IsScheme), // 是否启用活动方案区域，0未启用，1启用
        SchemeTitle: this.datas.SchemeTitle, // 活动方案区域标题
        SchemeContent: this.datas.Policy, // 活动政策
        IsGoods: Number(this.datas.IsGoods), // 是否启用活动商品，0未启用，1启用
        GoodsTitle1: this.datas.GoodsTitle1, // 秒杀标题
        GoodsTitle2: this.datas.GoodsTtitle2, // 商品标题
        IsBrand: Number(this.datas.IsBrand), // 是否启用活动品牌，0未启用，1启用
        BrandTitle: this.datas.BrandTittle, // 活动品牌区域标题
        IsAddress: Number(this.datas.IsAddress), // 是否启用活动地址，0未启用，1启用
        AddressTitle: this.datas.AddressTitle, // 活动地址区域标题
        Address: this.datas.Address // 活动地点
      };
      if (this.type == 0) { // 新增
        obj.OperId = localStorage.Id,
        obj.Guid = this.guid,
        InsertRegionOfflineActive(obj).then(data => {
          this.loading = false;
          this.$emit("loadingfun", this.loading);
          if (data.ResultCode == 1) {
              this.$swal({
                type:"success",
                text:"保存成功"
              })
              this.$router.go(-1)
          }
        });
      } else { // 修改
        obj.id = this.id,
        obj.Guid = this.guid,
        UpdateRegionOfflineActive(obj).then(data => {
          this.loading = false;
          this.$emit("loadingfun", this.loading);
          if (data.ResultCode == 1) {
              this.$swal({
                type:"success",
                text:"保存成功"
              })
              this.$router.go(-1)
          }
        });
      }
    },
    // 取消按钮 返回上一级
    goback () {
      this.$router.go(-1);
    },
    // 活动政策
    beforeUploadPolicy(file) {
      // 获取富文本组件实例
      let quill = this.$refs.hdzcQuillEditor.quill;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
          var obj = {
          uploadType: 3,
          base64Img: e.target.result //给后台传的参数 base64格式的img参数
          };
          UploadImgForServer(obj).then(data => {
          if (data.ResultCode == 1) {
              // 获取光标所在位置
              let length = quill.getSelection(true).index;
              // 插入图片  res.info为服务器返回的图片地址
              quill.insertEmbed(length, "image",localStorage.BaseUrl+ data.ResultObj);
              // 调整光标到最后
              quill.setSelection(length + 1);
          } else {
              this.$message({
              message: "图片上传失败!",
              type: "error"
              });
          }
          });
      };
      return file;
    },
    // 活动地址
    beforeUploadAddress (file) {
      // 获取富文本组件实例
      let quill = this.$refs.hddzQuillEditor.quill;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
          var obj = {
          uploadType: 3,
          base64Img: e.target.result //给后台传的参数 base64格式的img参数
          };
          UploadImgForServer(obj).then(data => {
          if (data.ResultCode == 1) {
              // 获取光标所在位置
              let length = quill.getSelection(true).index;
              // 插入图片  res.info为服务器返回的图片地址
              quill.insertEmbed(length, "image",localStorage.BaseUrl+ data.ResultObj);
              // 调整光标到最后
              quill.setSelection(length + 1);
          } else {
              this.$message({
              message: "图片上传失败!",
              type: "error"
              });
          }
          });
      };
      return file;
    },
    // 活动商品列表分页
    hdspCurrentChange(val){
      this.pageIndex = val;
      this.getHdspList();
    },
    // 活动品牌列表分页
    hdppCurrentChange(val){
     this.pageIndexTwo = val;
     this.gethdppList();
    },
    // 活动时间
    changetime() {
      if(this.hdsj + "" == "null"){
        this.hdsj = ["",""]
      }
      this.datas.STime = this.hdsj[0];
      this.datas.ETime = this.hdsj[1];
    },
    // 参展商品-单条删除
    deleteone(scope){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除当前参展商品吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          if(this.datas.Goods.length ==1){
            this.pageIndex = 1
          }
          var obj = {
            guid: this.guid,
            goodsId: scope.row.GoodsId,
          }
          DeleteGoods(obj).then(data=>{
            if(data.ResultCode == 1){
                if(this.goodIdarr.length == this.datas.Goods.length){
                  if( this.pageIndex>1){
                    this.pageIndex = this.pageIndex-1
                  }else{
                      this.pageIndex = 1
                  }
                }
              this.getHdspList()
            }
          })
        }
      })
    },
    //参展商品-操作向上 & 向下
    spUpordown(val,scope){
      var obj = {
        guid: this.guid,
        goodsId: scope.row.GoodsId,
        opType: val
      }
      UpdateGoodsOrderNum(obj).then(data=>{
        if(data.ResultCode == 1){
          this.getHdspList()
        }
      })
    },
    // 参展品牌-单条删除
    deleteTwo(scope){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除当前参展商品吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          if(this.datas.Brands.length ==1){
            this.pageIndexTwo = 1
          }
          var obj = {
            guid: this.guid,
            brandId: scope.row.BrandId,
          }
          DeleteBrands(obj).then(data=>{
            if(data.ResultCode == 1){
                if(this.goodIdarr.length == this.datas.Brands.length){
                  if( this.pageIndexTwo>1){
                    this.pageIndexTwo = this.pageIndexTwo-1
                  }else{
                      this.pageIndexTwo = 1
                  }
                }
              this.gethdppList();
            }
          })
        }
      })
    },
    //参展品牌-操作向上 & 向下
    ppUpordown(val,scope){
      var obj = {
        guid: this.guid,
        brandId: scope.row.BrandId,
        opType: val
      }
      UpdateBrandsOrderNum(obj).then(data=>{
        if(data.ResultCode == 1){
          this.gethdppList();
        }
      })
    },
    // 尺寸限制 1920*450
    beforeAvatarUpload(file) {
        const isJPG = file.type
        console.log(isJPG,"isJPG")
        if (isJPG !='image/jpeg'&&isJPG !='image/png'){
            this.$swal({
            type:"warning",
            text:"上传图片格式应为jpg/png"
            })
        return false
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 1920;
          let height = 450;
          console.log(width, height);
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
            var that = this;
            var reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = function(e) {
                var obj = {
                  base64Img:e.target.result,
                  uploadType:3
                }
                UploadImgForServer(obj).then(data=>{
                  if(data.ResultCode == 1){
                    that.datas.Pc_Banner = data.ResultObj;
                    that.ResultUrlPc = localStorage.BaseUrl+data.ResultObj
                  }
                })
            };
            return file;
            },
            () => {
                this.$swal({
                type:"warning",
                text:"上传图片尺寸应为1920*450"
                })
            return Promise.reject();
            }
        );
        return isSize;
    },
    // 尺寸限制: 750*750
    beforeAvatarUploadtwo(file) {
        const isJPG = file.type
        if (isJPG !='image/jpeg'&&isJPG !='image/png'){
            this.$swal({
            type:"warning",
            text:"上传图片格式应为jpg/png"
            })
        return false
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 750;
          console.log(width, height);
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
            var that = this;
            var reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = function(e) {
                var obj = {
                  base64Img:e.target.result,
                  uploadType:3
                }
                UploadImgForServer(obj).then(data=>{
                  if(data.ResultCode == 1){
                    that.datas.Wechat_Banner = data.ResultObj;
                    that.ResultUrlXcx = localStorage.BaseUrl+data.ResultObj
                  }
                })
            };
            return file;
            },
            () => {
                this.$swal({
                type:"warning",
                text:"上传图片尺寸应为750*750"
                })
            return Promise.reject();
            }
        );
        return isSize;
    },
    // 所属城市
    handleChange(val) {
      var obj = {}
      // 获取guid
      getCreateGUID(obj).then(data=>{
        if(data.ResultCode == 1){
            this.guid = data.ResultObj
        }
      })
      this.getHdspList();
      this.gethdppList();
      this.datas.ProviceId = val[0];
      this.datas.CityId = val[1];
    },
    // 查找省+市
    getprovince() {
      var loginParams = {
        isOpen: 0,
        dataLevel: 2
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then(data => {
        let that = this;
        let cityList = [];
        data.ResultObj.map(item => {
          let cityData = {value:item.Id,label:item.Name,children:[]}
          cityList.push(cityData)
          item.CityList.map(city => {
            cityData.children.push({value:city.Id, label:city.Name})
          })
        });
        that.options = cityList
      });
    },
  },
  mounted() {
    this.init()
    this.getprovince();
  },
}
</script>
<style scoped>
.mainbanner .el-upload--picture-card {
  width: 500px;
  height: 250px;
  line-height: 250px !important;
}
.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 650px;
  height: 270px;
  line-height: 270px;
  border: 1px solid #eeeeee;
  text-align: center;
}
.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 270px;
  height: 270px;
  line-height: 270px;
  border: 1px solid #eeeeee;
  text-align: center;
}
.avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}
.isshowspan {
  display: inline-block;
  margin-top: 10px;
}
.mainbanner {
  display: flex;
}
.spanimg {
  width: 500px;
  height: 250px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 500px;
  height: 250px;
  display: block;
}
.upload .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 170px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eeeeee;
  text-align: center;
}
.upload .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.fengmian .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.fengmian .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.fengmian .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 360px;
  height: 180px;
  line-height: 180px;
  border: 1px solid #eeeeee;
  text-align: center;
}
.fengmian .avatar {
  width: 360px;
  height: 180px;
  display: block;
}
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor:pointer
}
.inputDiv {
  width: 100%;
  padding: 10px 0;
}
.showDiv {
  width: 97%;
  padding: 10px;
  border: 1px solid #eee;
}
.jbxx {
  width: 99%;
  height: 30px;
  border-bottom: 1px solid #eee;
}
.addCanzhan {
  width: 100px;
  height: 36px;
  background: #e8f2fe;
  border-radius: 5px;
  border: 1px solid #7bacec;
  color: #2878ff;
  cursor: pointer;
  outline: none;
}
.jbxxDiv {
  width: 97%;
  padding: 10px 0 0 20px;
}
/* 基础信息title */
.jbxx {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #eee;
}
/* 保存提交 */
.suBmit {
  display:flex;
  margin-top:60px;
  padding-bottom:30px;
  margin-left:40%;
}
.tempSpan>span {
  color:#6786b4;
  margin-left:8px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// ActivityDetails.vue?411c6d2e